export const FETCH_CONTACT_REQUEST = 'contacts/FETCH_CONTACT_REQUEST';
export const FETCH_CONTACT_SUCCESS = 'contacts/FETCH_CONTACT_SUCCESS';
export const FETCH_CONTACT_FAILURE = 'contacts/FETCH_CONTACT_FAILURE';

export const FETCH_CONTACTS_REQUEST = 'contacts/FETCH_CONTACTS_REQUEST';
export const FETCH_CONTACTS_SUCCESS = 'contacts/FETCH_CONTACTS_SUCCESS';
export const FETCH_CONTACTS_FAILURE = 'contacts/FETCH_CONTACTS_FAILURE';

export const FETCH_CONTACTS_ALL_BY_SCHOOL_REQUEST = 'writing/FETCH_CONTACTS_ALL_BY_SCHOOL_REQUEST';
export const FETCH_CONTACTS_ALL_BY_SCHOOL_SUCCESS = 'writing/FETCH_CONTACTS_ALL_BY_SCHOOL_SUCCESS';
export const FETCH_CONTACTS_ALL_BY_SCHOOL_FAILURE = 'writing/FETCH_CONTACTS_ALL_BY_SCHOOL_FAILURE';

export const FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_REQUEST = 'writing/FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_REQUEST';
export const FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_SUCCESS = 'writing/FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_SUCCESS';
export const FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_FAILURE = 'writing/FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_FAILURE';

export const FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_REQUEST = 'writing/FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_REQUEST';
export const FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_SUCCESS = 'writing/FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_SUCCESS';
export const FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_FAILURE = 'writing/FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_FAILURE';

export const FETCH_CONTACTS_BY_CLAZZ_GROUP_REQUEST = 'contacts/FETCH_CONTACTS_BY_CLAZZ_GROUP_REQUEST';
export const FETCH_CONTACTS_BY_CLAZZ_GROUP_SUCCESS = 'contacts/FETCH_CONTACTS_BY_CLAZZ_GROUP_SUCCESS';
export const FETCH_CONTACTS_BY_CLAZZ_GROUP_FAILURE = 'contacts/FETCH_CONTACTS_BY_CLAZZ_GROUP_FAILURE';

export const FETCH_CONTACTS_BY_CUSTOM_GROUP_REQUEST = 'contacts/FETCH_CONTACTS_BY_CUSTOM_GROUP_REQUEST';
export const FETCH_CONTACTS_BY_CUSTOM_GROUP_SUCCESS = 'contacts/FETCH_CONTACTS_BY_CUSTOM_GROUP_SUCCESS';
export const FETCH_CONTACTS_BY_CUSTOM_GROUP_FAILURE = 'contacts/FETCH_CONTACTS_BY_CUSTOM_GROUP_FAILURE';

export const FETCH_CONTACTS_COUNT_REQUEST = 'contacts/FETCH_CONTACTS_COUNT_REQUEST';
export const FETCH_CONTACTS_COUNT_SUCCESS = 'contacts/FETCH_CONTACTS_COUNT_SUCCESS';
export const FETCH_CONTACTS_COUNT_FAILURE = 'contacts/FETCH_CONTACTS_COUNT_FAILURE';

export const FETCH_GROUPS_REQUEST = 'contacts/FETCH_GROUPS_REQUEST';
export const FETCH_GROUPS_SUCCESS = 'contacts/FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAILURE = 'contacts/FETCH_GROUPS_FAILURE';

export const CREATE_CLAZZ_GROUP_REQUEST = 'contacts/CREATE_CLAZZ_GROUP_REQUEST';
export const CREATE_CLAZZ_GROUP_SUCCESS = 'contacts/CREATE_CLAZZ_GROUP_SUCCESS';
export const CREATE_CLAZZ_GROUP_FAILURE = 'contacts/CREATE_CLAZZ_GROUP_FAILURE';

export const CREATE_CUSTOM_GROUP_REQUEST = 'contacts/CREATE_CUSTOM_GROUP_REQUEST';
export const CREATE_CUSTOM_GROUP_SUCCESS = 'contacts/CREATE_CUSTOM_GROUP_SUCCESS';
export const CREATE_CUSTOM_GROUP_FAILURE = 'contacts/CREATE_CUSTOM_GROUP_FAILURE';

export const UPDATE_CUSTOM_GROUP_REQUEST = 'contacts/UPDATE_CUSTOM_GROUP_REQUEST';
export const UPDATE_CUSTOM_GROUP_SUCCESS = 'contacts/UPDATE_CUSTOM_GROUP_SUCCESS';
export const UPDATE_CUSTOM_GROUP_FAILURE = 'contacts/UPDATE_CUSTOM_GROUP_FAILURE';

export const UPDATE_CONTACT_REQUEST = 'contacts/UPDATE_CONTACT_REQUEST';
export const UPDATE_CONTACT_SUCCESS = 'contacts/UPDATE_CONTACT_SUCCESS';
export const UPDATE_CONTACT_FAILURE = 'contacts/UPDATE_CONTACT_FAILURE';

export const DELETE_CONTACTS_REQUEST = 'contacts/DELETE_CONTACTS_REQUEST';
export const DELETE_CONTACTS_SUCCESS = 'contacts/DELETE_CONTACTS_SUCCESS';
export const DELETE_CONTACTS_FAILURE = 'contacts/DELETE_CONTACTS_FAILURE';

export const DELETE_CONTACTS_ALL_REQUEST = 'contacts/DELETE_CONTACTS_ALL_REQUEST';
export const DELETE_CONTACTS_ALL_SUCCESS = 'contacts/DELETE_CONTACTS_ALL_SUCCESS';
export const DELETE_CONTACTS_ALL_FAILURE = 'contacts/DELETE_CONTACTS_ALL_FAILURE';

export const EXCHANGE_GUARDIAN_CONTACTS_REQUEST = 'contacts/EXCHANGE_GUARDIAN_CONTACTS_REQUEST';
export const EXCHANGE_GUARDIAN_CONTACTS_SUCCESS = 'contacts/EXCHANGE_GUARDIAN_CONTACTS_SUCCESS';
export const EXCHANGE_GUARDIAN_CONTACTS_FAILURE = 'contacts/EXCHANGE_GUARDIAN_CONTACTS_FAILURE';

export const APPLY_CHANGED_GROUPS_REQUEST = 'contacts/APPLY_CHANGED_GROUPS_REQUEST';
export const APPLY_CHANGED_GROUPS_SUCCESS = 'contacts/APPLY_CHANGED_GROUPS_SUCCESS';
export const APPLY_CHANGED_GROUPS_FAILURE = 'contacts/APPLY_CHANGED_GROUPS_FAILURE';

export const EXPORT_CONTACTS = 'contacts/EXPORT_CONTACTS';

export const CLEAR_ALL_CONTACTS_ERROR = 'contacts/CLEAR_ALL_CONTACTS_ERROR';
export const CLEAR_CONTACTS_ERROR = 'contacts/CLEAR_CONTACTS_ERROR';
export const CLEAR_CONTACTS_COUNT_ERROR = 'contacts/CLEAR_CONTACTS_COUNT_ERROR';
export const CLEAR_GROUPS_ERROR = 'contacts/CLEAR_GROUPS_ERROR';
export const CLEAR_CONTACTS_DELETED_ERROR = 'contacts/CLEAR_CONTACTS_DELETED_ERROR';

export const PUSH_FAILED_CONTACTS_DELETED_ID = 'contacts/PUSH_FAILED_CONTACTS_DELETED_ID';

export const INIT_CONTACT = 'contacts/INIT_CONTACT';

export const INIT_CONTACTS = 'contacts/INIT_CONTACTS';

export const INIT_ALL_CONTACTS = 'contacts/INIT_ALL_CONTACTS';

export const INIT_CREATION_TASK = 'contacts/INIT_CREATION_TASK';

export const INIT_UPDATE_TASK = 'contacts/INIT_UPDATE_TASK';

export const INIT_UPDATED = 'contacts/INIT_UPDATED';

export const INIT_CONTACTS_DELETED = 'contacts/INIT_CONTACTS_DELETED';

export const CLEAR_FAILED_CONTACTS_DELETED_ID = 'contacts/CLEAR_FAILED_CONTACTS_DELETED_ID';

export const fetchContactRequest = (payload = {}) => ({
  type: FETCH_CONTACT_REQUEST,
  payload,
});
export const fetchContactSuccess = (payload = {}) => ({
  type: FETCH_CONTACT_SUCCESS,
  payload,
});
export const fetchContactFailure = (payload = {}) => ({
  type: FETCH_CONTACT_FAILURE,
  payload,
});

export const updateContactRequest = (payload = {}) => ({
  type: UPDATE_CONTACT_REQUEST,
  payload,
});
export const updateContactSuccess = (payload = {}) => ({
  type: UPDATE_CONTACT_SUCCESS,
  payload,
});
export const updateContactFailure = (payload = {}) => ({
  type: UPDATE_CONTACT_FAILURE,
  payload,
});

export const deleteContactsRequest = (payload = {}) => ({
  type: DELETE_CONTACTS_REQUEST,
  payload,
});
export const deleteContactsSuccess = (payload = {}) => ({
  type: DELETE_CONTACTS_SUCCESS,
  payload,
});
export const deleteContactsFailure = (payload = {}) => ({
  type: DELETE_CONTACTS_FAILURE,
  payload,
});

export const deleteContactsAllRequest = (payload = {}) => ({
  type: DELETE_CONTACTS_ALL_REQUEST,
  payload,
});
export const deleteContactsAllSuccess = (payload = {}) => ({
  type: DELETE_CONTACTS_ALL_SUCCESS,
  payload,
});
export const deleteContactsAllFailure = (payload = {}) => ({
  type: DELETE_CONTACTS_ALL_FAILURE,
  payload,
});

export const fetchContactsRequest = (payload = {}) => ({
  type: FETCH_CONTACTS_REQUEST,
  payload,
});
export const fetchContactsSuccess = (payload = {}) => ({
  type: FETCH_CONTACTS_SUCCESS,
  payload,
});
export const fetchContactsFailure = (payload = {}) => ({
  type: FETCH_CONTACTS_FAILURE,
  payload,
});

export const fetchContactsAllBySchoolRequest = (payload = {}) => ({
  type: FETCH_CONTACTS_ALL_BY_SCHOOL_REQUEST,
  payload,
});
export const fetchContactsAllBySchoolSuccess = (payload = {}) => ({
  type: FETCH_CONTACTS_ALL_BY_SCHOOL_SUCCESS,
  payload,
});
export const fetchContactsAllBySchoolFailure = (payload = {}) => ({
  type: FETCH_CONTACTS_ALL_BY_SCHOOL_FAILURE,
  payload,
});

export const fetchContactsAllByClazzGroupRequest = (payload = {}) => ({
  type: FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_REQUEST,
  payload,
});
export const fetchContactsAllByClazzGroupSuccess = (payload = {}) => ({
  type: FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_SUCCESS,
  payload,
});
export const fetchContactsAllByClazzGroupFailure = (payload = {}) => ({
  type: FETCH_CONTACTS_ALL_BY_CLAZZ_GROUP_FAILURE,
  payload,
});

export const fetchContactsAllByCustomGroupRequest = (payload = {}) => ({
  type: FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_REQUEST,
  payload,
});
export const fetchContactsAllByCustomGroupSuccess = (payload = {}) => ({
  type: FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_SUCCESS,
  payload,
});
export const fetchContactsAllByCustomGroupFailure = (payload = {}) => ({
  type: FETCH_CONTACTS_ALL_BY_CUSTOM_GROUP_FAILURE,
  payload,
});

export const fetchContactsByClazzGroupRequest = (payload = {}) => ({
  type: FETCH_CONTACTS_BY_CLAZZ_GROUP_REQUEST,
  payload,
});
export const fetchContactsByClazzGroupSuccess = (payload = {}) => ({
  type: FETCH_CONTACTS_BY_CLAZZ_GROUP_SUCCESS,
  payload,
});
export const fetchContactsByClazzGroupFailure = (payload = {}) => ({
  type: FETCH_CONTACTS_BY_CLAZZ_GROUP_FAILURE,
  payload,
});

export const fetchContactsByCustomGroupRequest = (payload = {}) => ({
  type: FETCH_CONTACTS_BY_CUSTOM_GROUP_REQUEST,
  payload,
});
export const fetchContactsByCustomGroupSuccess = (payload = {}) => ({
  type: FETCH_CONTACTS_BY_CUSTOM_GROUP_SUCCESS,
  payload,
});
export const fetchContactsByCustomGroupFailure = (payload = {}) => ({
  type: FETCH_CONTACTS_BY_CUSTOM_GROUP_FAILURE,
  payload,
});

export const fetchContactsCountRequest = (payload = {}) => ({
  type: FETCH_CONTACTS_COUNT_REQUEST,
  payload,
});
export const fetchContactsCountSuccess = (payload = {}) => ({
  type: FETCH_CONTACTS_COUNT_SUCCESS,
  payload,
});
export const fetchContactsCountFailure = (payload = {}) => ({
  type: FETCH_CONTACTS_COUNT_FAILURE,
  payload,
});

export const fetchGroupsRequest = (payload = {}) => ({
  type: FETCH_GROUPS_REQUEST,
  payload,
});
export const fetchGroupsSuccess = (payload = {}) => ({
  type: FETCH_GROUPS_SUCCESS,
  payload,
});
export const fetchGroupsFailure = (payload = {}) => ({
  type: FETCH_GROUPS_FAILURE,
  payload,
});

export const createClazzGroupRequest = (payload = {}) => ({
  type: CREATE_CLAZZ_GROUP_REQUEST,
  payload,
});
export const createClazzGroupSuccess = (payload = {}) => ({
  type: CREATE_CLAZZ_GROUP_SUCCESS,
  payload,
});
export const createClazzGroupFailure = (payload = {}) => ({
  type: CREATE_CLAZZ_GROUP_FAILURE,
  payload,
});

export const createCustomGroupRequest = (payload = {}) => ({
  type: CREATE_CUSTOM_GROUP_REQUEST,
  payload,
});
export const createCustomGroupSuccess = (payload = {}) => ({
  type: CREATE_CUSTOM_GROUP_SUCCESS,
  payload,
});
export const createCustomGroupFailure = (payload = {}) => ({
  type: CREATE_CUSTOM_GROUP_FAILURE,
  payload,
});

export const updateCustomGroupRequest = (payload = {}) => ({
  type: UPDATE_CUSTOM_GROUP_REQUEST,
  payload,
});
export const updateCustomGroupSuccess = (payload = {}) => ({
  type: UPDATE_CUSTOM_GROUP_SUCCESS,
  payload,
});
export const updateCustomGroupFailure = (payload = {}) => ({
  type: UPDATE_CUSTOM_GROUP_FAILURE,
  payload,
});

export const exchangeGuardianContactsRequest = (payload = {}) => ({
  type: EXCHANGE_GUARDIAN_CONTACTS_REQUEST,
  payload,
});
export const exchangeGuardianContactsSuccess = (payload = {}) => ({
  type: EXCHANGE_GUARDIAN_CONTACTS_SUCCESS,
  payload,
});
export const exchangeGuardianContactsFailure = (payload = {}) => ({
  type: EXCHANGE_GUARDIAN_CONTACTS_FAILURE,
  payload,
});

export const applyChangedGroupsRequest = (payload = {}) => ({
  type: APPLY_CHANGED_GROUPS_REQUEST,
  payload,
});
export const applyChangedGroupsSuccess = (payload = {}) => ({
  type: APPLY_CHANGED_GROUPS_SUCCESS,
  payload,
});
export const applyChangedGroupsFailure = (payload = {}) => ({
  type: APPLY_CHANGED_GROUPS_FAILURE,
  payload,
});

export const exportContacts = (payload = {}) => ({
  type: EXPORT_CONTACTS,
  payload,
});

export const clearAllContactsError = () => ({
  type: CLEAR_ALL_CONTACTS_ERROR,
});

export const clearContactsError = () => ({
  type: CLEAR_CONTACTS_ERROR,
});

export const clearContactsCountError = () => ({
  type: CLEAR_CONTACTS_COUNT_ERROR,
});

export const clearGroupsError = () => ({
  type: CLEAR_GROUPS_ERROR,
});

export const pushFailedContactsDeletedId = (payload = {}) => ({
  type: PUSH_FAILED_CONTACTS_DELETED_ID,
  payload,
});

export const clearFailedContactsDeletedId = () => ({
  type: CLEAR_FAILED_CONTACTS_DELETED_ID,
});

export const clearContactsDeletedError = () => ({
  type: CLEAR_CONTACTS_DELETED_ERROR,
});

export const initContact = (payload = {}) => ({
  type: INIT_CONTACT,
  payload,
});

export const initContacts = (payload = {}) => ({
  type: INIT_CONTACTS,
  payload,
});

export const initAllContacts = (payload = {}) => ({
  type: INIT_ALL_CONTACTS,
  payload,
});

export const initCreationTask = (payload = {}) => ({
  type: INIT_CREATION_TASK,
  payload,
});

export const initUpdateTask = (payload = {}) => ({
  type: INIT_UPDATE_TASK,
  payload,
});

export const initUpdated = (payload = {}) => ({
  type: INIT_UPDATED,
  payload,
});

export const initContactsDeleted = (payload = {}) => ({
  type: INIT_CONTACTS_DELETED,
  payload,
});
